/** @jsxImportSource @emotion/react */

import React, { useState, useEffect } from "react";

import Button from "@material-ui/core/Button";

import axios from "axios";
import CircularProgress from "@material-ui/core/CircularProgress";

import { useStoreon } from "storeon/react";
import Input from "@material-ui/core/Input";
// import { SIZES } from "../constants";

const SaveEditorButtons = () => {
  const { dispatch, canvas, id, editors } = useStoreon(
    "canvas",
    "id",
    "editors"
  );
  const [isLoading, setLoading] = useState(false);
  const [title, setTitle] = useState("");

  useEffect(
    _ => {
      if (id === null) {
        setTitle("");
      }
      editors.forEach(editor => {
        if (editor.id === id) {
          setTitle(editor.title);
        }
      });
    },
    [id, editors]
  );

  const handleClick = () => {
    const canvasData = canvas.DPE.persistent.toBase64();
    setLoading(true);
    axios
      .post("/wp-json/dpe/v1/editor", {
        title,
        id,
        canvasData,
        settings: canvas.settings
      })
      .then(resp => {
        setLoading(false);
        const { editors, id } = resp.data;
        if (id) {
          dispatch("id/set", id);
          dispatch("notification/success", `Editor ID:${id} saved!`);
        }
        if (editors) {
          dispatch("editors/set", editors);
        }
      })
      .catch(err => {
        console.error("Server loading external image failed", err);
      });
  };

  // const handleNewClick = () => {
  //   canvas.clear();
  //   canvas.DPE.cutZone.initBounds();
  //   canvas.DPE.cutZone.initClipZone();
  //   canvas.requestRenderAll();
  //   canvas.DPE.cutZone.fitCutZone();
  //   setTitle("");
  //   dispatch("id/set", null);
  // };

  const handleTitleChange = e => {
    setTitle(e.target.value);
  };

  return (
    <React.Fragment>
      <Input
        placeholder="Editor title"
        value={title}
        onChange={handleTitleChange}
        style={{ marginRight: 10 }}
        inputProps={{ style: { paddingLeft: 10 } }}
      />
      <Button
        variant="contained"
        color="secondary"
        disabled={isLoading}
        style={{ marginRight: 10 }}
        onClick={handleClick}
      >
        Save editor
        {isLoading && <CircularProgress size={24} style={{ marginLeft: 10 }} />}
      </Button>
      {/* <Button variant="contained" disabled={isLoading} onClick={handleNewClick}>
        New
        {isLoading && <CircularProgress size={24} style={{ marginLeft: 10 }} />}
      </Button> */}
    </React.Fragment>
  );
};

export default SaveEditorButtons;
